import React from "react";

const style = {
  cols: {
    col1: "sm:grid-cols-1",
    col2: "sm:grid-cols-2",
    col3: "sm:grid-cols-3",
  },
  gapX: {
    gapX4: "gap-x-4",
    gapX36: "gap-x-36",
  },
  gapY: {
    gapY4: "gap-y-4",
    gapY8: "gap-y-8",
  },
};
export type filed = {
  [key: string]: any;
};

export type InfoBoardProps = {
  children: React.ReactNode;
  className?: string;
  col?: "col1" | "col2" | "col3";
  gapX?: "gapX4" | "gapX36";
  gapY?: "gapY4" | "gapY8";
  vertical?: boolean;
  filed: filed;
  flexDisp?: boolean;
};

export const InfoBoard = ({ filed, col = "col2", gapX = "gapX4", gapY = "gapY8", flexDisp = false }: InfoBoardProps) => {
  return (
    <div className={`${flexDisp? "mt-2" : "mt-6"} max-w-5xl px-4 sm:px-6 lg:px-8`}>
      <dl className={`grid grid-cols-1 ${style.gapX[gapX]} ${style.gapY[gapY]} ${style.cols[col]}`}>
        {Object.keys(filed).map((field) => (
          <div key={field} className={`sm:col-span-1 ${flexDisp? "flex" : ""}`}>
            <dt className={`text-sm text-gray-500 ${flexDisp? "w-[110px] text-right mr-8 whitespace-nowrap" : ""}`}>{field}</dt>
            <dd className={`text-sm text-gray-900 whitespace-pre-line ${flexDisp? "" : "mt-1"}`}>{filed[field]}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};


